import { ApiV2 } from 'src/api/apiv2';
import { HEADERS } from 'src/constants/headers';
import { CONVERSATIONS_ENDPOINT } from './constants';
import { getApiErrorMessage } from './getApiErrorMessage';
import { TChannelSendResult, TSendChannelTemplateBody } from './types';

const ERROR_CANNOT_SEND_TEMPLATE = 'Errors.CannotSendWsp';

/**
 * Sends a template on a `WarboxConversation`, creating it when needed.
 * The only call to `/conversations/sendTemplate`.
 *
 * @throws Error whose message is the backend error (e.g. `Errors.NoActiveConversationChannel`)
 */
export const sendChannelTemplate = async (
    body: TSendChannelTemplateBody
): Promise<TChannelSendResult> => {
    try {
        const response = await ApiV2.post(
            CONVERSATIONS_ENDPOINT.SEND_TEMPLATE,
            body,
            HEADERS()
        );
        return response.data?.data;
    } catch (error) {
        throw new Error(getApiErrorMessage(error, ERROR_CANNOT_SEND_TEMPLATE));
    }
};
